module.exports = __webpack_public_path__ + "static/robot-164bd87856ff630d10389b64d93c82a2.gif";